import {Button} from "../ui-components/Button/Button";
import React, {useContext, useState} from "react";
import {ToastService} from "../../service/ToastService";
import {PreviewDataContext} from "../../context/PreviewContext";
import {SignatureModal} from "../SignatureModal/SignatureModal";
import {InvoiceContext} from "../../context/InvoiceContext";
import {acceptSignaturesAsync, rejectSignaturesAsync} from "../../api/SignatureApi";
import {SignatureRejectModal} from "../SignatureRejectModal/SignatureRejectModal";
import {PageContext} from "../../context/PageContext";
import {PreloaderContext} from "../../context/PreloaderContext";


export const SignatureReject: React.FunctionComponent = (props) => {
    const previewContext = useContext(PreviewDataContext);
    const [signatureRejectModalVisible, setSignatureRejectModalVisible] = useState<boolean>(false);
    const pageContext = useContext(PageContext);
    const preloaderContext = useContext(PreloaderContext);

    const onClick = () => {
        if (previewContext.isPreviewMode) {
            ToastService.middleScreenWarningToast('This button is not available in preview mode.');
            return;
        }
        setSignatureRejectModalVisible(true);
    }

    const onCloseSignatureRejectModal = () => {
        setSignatureRejectModalVisible(false);
    }

    const onSubmitSignatureRejectModal = (rejectReason: string) => {
        sendSignatureRejectRequest(rejectReason);
    }

    const sendSignatureRejectRequest = async (rejectReason: string) => {
        preloaderContext.showMiddlePagePreloader();
        const response = await rejectSignaturesAsync(rejectReason).catch(() => {
        });
        preloaderContext.hideMiddlePagePreloader();
        if (response && !response.error) {
            onCloseSignatureRejectModal();
            pageContext.setPage(response?.response?.status);
        } else if (!response || (response && response.error)) {
            if (response && response.errors && response.errors.length) {
                ToastService.middleScreenErrorToast(response.errors.join('\n'));
            } else {
                ToastService.middleScreenErrorToast('Please try again or contact FieldPulse support.');
            }
        }
    }

    return (<div>{signatureRejectModalVisible ?
        <SignatureRejectModal onSubmitModal={onSubmitSignatureRejectModal}
                              onCloseModal={onCloseSignatureRejectModal}/> : null}
        <Button
            onClick={onClick} className="cancel-button signature-reject-button">Reject Contract</Button></div>)
}